import { useEffect, useRef, useState } from "react";
import { GameShell, useGameLoop, beep, useTouchSwipe } from "./_gameKit";

const LANES = 3;
export default function JixxeoSwipeDodge() {
  const canvasRef = useRef(null);
  const [lane, setLane] = useState(1);
  const [running, setRunning] = useState(true);
  const [time, setTime] = useState(60);
  const [score, setScore] = useState(0);
  const [best, setBest] = useState(() => Number(localStorage.getItem("jixxeo_swipe_best") || 0));
  const blocksRef = useRef([]);
  const spawnRef = useRef(0);
  const laneRef = useRef(1);
  useEffect(() => { laneRef.current = lane; }, [lane]);

  useEffect(() => {
    const kd = (e) => {
      if (!running) return;
      const k = e.key;
      if (k === "ArrowLeft" || k === "a") setLane((l) => Math.max(0, l - 1));
      if (k === "ArrowRight" || k === "d") setLane((l) => Math.min(LANES - 1, l + 1));
    };
    window.addEventListener("keydown", kd);
    return () => window.removeEventListener("keydown", kd);
  }, [running]);
  useTouchSwipe((dir) => {
    if (!running) return;
    if (dir === "left") setLane((l) => Math.max(0, l - 1));
    if (dir === "right") setLane((l) => Math.min(LANES - 1, l + 1));
  });

  useEffect(() => {
    if (!running) return;
    const t = setInterval(() => setTime((s) => {
      if (s <= 1) { setRunning(false); return 0; }
      return s - 1;
    }), 1000);
    return () => clearInterval(t);
  }, [running]);

  useGameLoop(canvasRef, ({ ctx, w, h, dt }) => {
    ctx.fillStyle = "#050510"; ctx.fillRect(0, 0, w, h);
    // grid glow
    ctx.strokeStyle = "rgba(0,240,255,0.15)";
    for (let i = 1; i < LANES; i++) {
      const x = (w / LANES) * i;
      ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, h); ctx.stroke();
    }
    // spawn
    spawnRef.current -= dt;
    if (running && spawnRef.current <= 0) {
      spawnRef.current = 0.55 - Math.min(0.3, (60 - time) * 0.008);
      blocksRef.current.push({ lane: Math.floor(Math.random() * LANES), y: -60, v: 220 + Math.random() * 120, color: ["#00F0FF","#39FF14","#FFE300","#FF003C"][Math.floor(Math.random()*4)] });
    }
    // move + draw
    const laneW = w / LANES;
    blocksRef.current = blocksRef.current.filter((b) => {
      if (running) b.y += b.v * dt;
      ctx.fillStyle = b.color;
      ctx.shadowColor = b.color; ctx.shadowBlur = 18;
      ctx.fillRect(b.lane * laneW + 20, b.y, laneW - 40, 40);
      ctx.shadowBlur = 0;
      // collision with player
      const py = h - 90;
      if (running && b.lane === laneRef.current && b.y + 40 > py && b.y < py + 60) {
        setRunning(false); beep(120, 0.3);
      }
      return b.y < h + 40;
    });
    if (running && blocksRef.current.length) setScore((s) => s + Math.round(dt * 30));
    // player
    const px = laneRef.current * laneW + laneW / 2;
    const py = h - 60;
    ctx.fillStyle = "#00F0FF"; ctx.shadowColor = "#00F0FF"; ctx.shadowBlur = 24;
    ctx.beginPath(); ctx.moveTo(px, py - 22); ctx.lineTo(px - 22, py + 20); ctx.lineTo(px + 22, py + 20); ctx.closePath(); ctx.fill();
    ctx.shadowBlur = 0;
  }, running);

  useEffect(() => {
    if (!running && score > best) { setBest(score); localStorage.setItem("jixxeo_swipe_best", String(score)); }
  }, [running, score, best]);

  const restart = () => { blocksRef.current = []; setLane(1); setScore(0); setTime(60); setRunning(true); };

  return (
    <GameShell canvasRef={canvasRef} title="Jixxeo Swipe Dodge" accent="#00F0FF"
      adGame="jixxeo-swipe-dodge"
      chips={[["Time", time + "s"], ["Score", score], ["Best", best]]}
      instructions="Arrows / A-D or swipe left-right"
      gameOver={!running && time === 0 ? { title: "Time!", subtitle: `Score ${score}` } : (!running ? { title: "Crashed", subtitle: `Score ${score}` } : null)}
      onRestart={restart}
    />
  );
}
